import { MainAndSupportColors, SeverityColors } from '@innovationnorway/cl-react/dist/types/colors';
import i18next from 'i18next';
import { OneWayInStatus, OneWayInOpportunitySimpleV2Dto } from 'src/api/v2';

export type StatusTag = {
  status: {
    status: (typeof OneWayInStatus)['Received'];
  };
};

export const translateStatusTag = (currentStatusTag: string | undefined) => {
  const { t } = i18next;

  let statusTagText = t<string>('oneWayIn:status.wip');

  if (currentStatusTag === OneWayInStatus.Opened) statusTagText = t<string>('oneWayIn:status.Opened');

  if (
    !currentStatusTag ||
    currentStatusTag === OneWayInStatus.Received ||
    currentStatusTag === OneWayInStatus.New ||
    currentStatusTag === OneWayInStatus.ReferredLater
  ) {
    statusTagText = t<string>('oneWayIn:status.New');
  }

  if (currentStatusTag === OneWayInStatus.AutoArchived) {
    statusTagText = t<string>('oneWayIn:status.AutoArchived');
  }

  if (currentStatusTag === OneWayInStatus.Closed || currentStatusTag === OneWayInStatus.Forwarded) {
    statusTagText = t<string>('oneWayIn:status.Archived');
  }

  if (currentStatusTag === OneWayInStatus.FollowUpLater) {
    statusTagText = t<string>('oneWayIn:status.FollowUpLater');
  }

  // Info: opportunities should no longer get status Shared from backend
  return statusTagText;
};

export function filterSelectedStatusTag(
  item: OneWayInOpportunitySimpleV2Dto,
  filterValue: (OneWayInStatus | null)[],
) {
  if (filterValue.length === 0) {
    return true;
  }

  if (!item.status) {
    return filterValue.includes(null);
  }

  return filterValue.includes(item.status.status);
}

export const determineTagType = (status: OneWayInStatus | undefined) => {
  let tagType: keyof MainAndSupportColors | SeverityColors | 'neutral' = 'success';

  if (
    !status ||
    status === OneWayInStatus.Received ||
    status === OneWayInStatus.New ||
    status === OneWayInStatus.Opened ||
    status === OneWayInStatus.ReferredLater
  ) {
    tagType = 'info';
  }

  if (
    status === OneWayInStatus.Closed ||
    status === OneWayInStatus.Forwarded ||
    status === OneWayInStatus.AutoArchived
  ) {
    tagType = 'neutral';
  }

  if (status === OneWayInStatus.FollowUpLater) {
    tagType = 'warning'; // Notice has name "none" for some reason
  }

  return tagType;
};

export const determineTagColor = (status: OneWayInStatus | undefined) => {
  let tagColor = '#cfffe3';

  if (
    !status ||
    status === OneWayInStatus.Received ||
    status === OneWayInStatus.New ||
    status === OneWayInStatus.Opened ||
    status === OneWayInStatus.ReferredLater
  ) {
    tagColor = '#d6f6ff';
  }

  if (
    status === OneWayInStatus.Closed ||
    status === OneWayInStatus.Forwarded ||
    status === OneWayInStatus.AutoArchived
  ) {
    tagColor = '#f2f2f2';
  }

  if (status === OneWayInStatus.FollowUpLater) {
    tagColor = '#fffddb';
  }

  return tagColor;
};
